import { ClipParticleImage } from '@local/assets/images'

import Image from '@web/components/Image'
import Alert from '@web/components/Modal/Alert'
import { useModal } from '@web/components/Modal/useModal'
import nClicks from '@web/libs/nlog/click/codes'

import styles from './modal.module.scss'

const useFirstClipCompleteModal = () => {
  const { openModal } = useModal(Alert, {
    label: {
      confirm: '확인',
    },
    title: (
      <>
        <div className={styles.tit_area}>
          <Image src={ClipParticleImage} width={246} height={246} alt="" className={styles.img_particle} />첫 번째
          클립이 만들어졌어요!
        </div>
      </>
    ),
    message: '앞으로도 다양한 장소를 클립으로 담아보세요.',
    clickCodes: {
      confirm: nClicks.reviewTab.CLIP_FIRST,
    },
    className: styles.first_modal_clip,
  })

  return { openModal }
}

export default useFirstClipCompleteModal
